import React from 'react'
import { clsx } from 'clsx'
import type { LucideIcon } from 'lucide-react'
import { STATE_LABELS } from '../constants'

interface A11yControlButtonProps {
  controlKey: string
  label: string
  Icon: LucideIcon
  currentState: string
  onClick: () => void
  isActive: boolean
}

export function A11yControlButton({
  controlKey,
  label,
  Icon,
  currentState,
  onClick,
  isActive,
}: A11yControlButtonProps): React.ReactElement {
  const stateLabels = STATE_LABELS[controlKey] || {}
  const displayState = stateLabels[currentState] || currentState

  return (
    <button
      onClick={onClick}
      className={clsx(
        'flex flex-col items-center justify-center gap-2 rounded-lg p-4 transition-all',
        'bg-sand-100 dark:bg-slate-800 hover:bg-sand-200 dark:hover:bg-slate-700',
        isActive && 'ring-2 ring-ocean-500 dark:ring-ocean-400'
      )}
      type="button"
      aria-label={`${label}: ${displayState}`}
    >
      <Icon className="h-6 w-6 text-slate-700 dark:text-sand-300" />
      <span className="text-center text-xs font-medium text-slate-700 dark:text-sand-300">
        {label}
      </span>
      <span className="text-center text-xs text-slate-500 dark:text-sand-400">
        {displayState}
      </span>
    </button>
  )
}
